import {Component, Inject, OnInit} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { ModalDialogData } from '../../models/modal-dialog.interface';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'app-modal-dialog',
  standalone: true,
  imports: [MatIconButton, MatIcon, MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose],
  templateUrl: './modal-dialog.component.html',
  styleUrl: './modal-dialog.component.scss',
})
export class ModalDialogComponent implements OnInit {
  constructor(
    private authService: AuthService,
    public dialogRef: MatDialogRef<ModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalDialogData
  ) {}

  ngOnInit() {
    this.authService.addOpenedDialog(this.dialogRef);
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }
}
